import { handleActions } from 'redux-actions';
import Immutable from 'seamless-immutable';
import actions from '../actions';

const initialState = Immutable({
  loading: false,
  initialized: false,
  facadeOpacity: 0,
  outlineColor: '#000000',
  elements: {},
});

export default handleActions(
  {
    [actions.model.load]: (state) =>
      state.merge({ loading: true, initialized: false }),
    [actions.model.ready]: (state) =>
      state.merge({ loading: false, initialized: true }),
    [actions.model.setDefaultOpacityForFacades]: (
      state,
      { payload: { facadeOpacity } },
    ) => state.merge({ facadeOpacity }),
    [actions.model.loadElements]: (state, { payload: { elements } }) =>
      state.set('elements', elements),
    [actions.model.addElement]: (state, { payload: { element } }) =>
      state.merge(
        {
          elements: {
            [element.uuid]: element,
          },
        },
        { deep: true },
      ),
  },
  initialState,
);
